export const styles = {
  textDecoration: {
    textDecoration: "none",
    height: "auto",
    margin: "3%"
  },
  modalContent: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center"
  },
  modalView: {
    display: "flex",
    width: "95%"
  }
};
